type ApiEndpointName = 'presignedUrl' | 'submit' | 'partners';

// Each site calls pf-developer-network on its environment's api.platform host;
// localhost goes through the next.config.ts proxy.
const API_BASE_URLS: Record<string, string> = {
  'pfdn.propertyfinder.com': 'https://api.platform.propertyfinder.com',
  'pfdn.staging.propertyfinder.com': 'https://api.platform.staging.propertyfinder.com',
  localhost: '',
};

const API_ENDPOINTS: Record<ApiEndpointName, string> = {
  presignedUrl: '/pfdn/v1/pre-signed-url',
  submit: '/pfdn/v1/submit',
  partners: '/pfdn/v1/partners',
};

export function getApiEndpoint(name: ApiEndpointName): string {
  return API_BASE_URLS[window.location.hostname] + API_ENDPOINTS[name];
}
